import type { NavigationGuardWithThis } from 'vue-router';
import type { CompanyPermissionsCodename } from 'src/api';
import { useUser } from 'stores/user/useUser';
import { deniedRedirect } from './deniedRedirect';

// Redirects to home when the company is missing the given company permission.
export const requireCompanyPermission = (
  permission: CompanyPermissionsCodename
): NavigationGuardWithThis<undefined> => {
  return (to, from, next): void => {
    const userStore = useUser();
    if (!userStore.handleCompanyHasPermission(permission)) {
      return next(deniedRedirect(to));
    }
    return next();
  };
};
